import { getCurrentInstance, onMounted, onUnmounted, ref, watch } from 'vue'

const DEV_MODE_STORAGE_KEY = 'xappCoreDevMode'

function readStoredDevMode() {
  if (typeof window === 'undefined') return false
  return window.localStorage.getItem(DEV_MODE_STORAGE_KEY) === 'true'
}

function writeStoredDevMode(value) {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(DEV_MODE_STORAGE_KEY, value ? 'true' : 'false')
}

const isDevMode = ref(readStoredDevMode())
let isListenerSetup = false

watch(isDevMode, (next) => {
  writeStoredDevMode(Boolean(next))
})

export function useDevMode() {
  const setDevMode = (nextValue) => {
    isDevMode.value = Boolean(nextValue)
    writeStoredDevMode(isDevMode.value)
  }

  const handleKey = (e) => {
    // console.log(e)
    // Ctrl + Shift + X (Studios)
    if (e.ctrlKey && e.shiftKey && e.key === 'X') {
      setDevMode(!isDevMode.value)
      return
    }

    // if (e.ctrlKey && e.shiftKey && e.key === 'V') {
    //   setDevMode(!isDevMode.value)
    // }
  }

  const inComponentSetup = Boolean(getCurrentInstance())

  // Only set up the listener once globally when invoked from setup()
  if (inComponentSetup && !isListenerSetup) {
    onMounted(() => {
      window.addEventListener('keydown', handleKey)
      isListenerSetup = true
    })

    onUnmounted(() => {
      window.removeEventListener('keydown', handleKey)
      isListenerSetup = false
    })
  }

  const enableDevMode = () => {
    setDevMode(true)
  }

  const disableDevMode = () => {
    setDevMode(false)
  }

  return { disableDevMode, enableDevMode, isDevMode }
}
